var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tender-card tender-card-skeleton"},[_c('v-skeleton-loader',{attrs:{"type":"sentences","width":"400"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }